import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'content-layout',
})

export default class ContentLayout extends Vue {


    // --------------------------------------------------------------------------
    // Properties

    @Prop()
    private toolPartners: any;

    private activeToolData: any = null;

    private filterData: any = {};

    private terms: string = '';



    // ----------------------------------------------------------------------------
    // Actions

    private onSelectTool(toolData: any) {
        this.activeToolData = toolData;
    }

    private onApplyFilter(filterData: any, searchTerms: string) {
        this.filterData = filterData;
        this.terms = searchTerms;
    }

    private onSearch(terms: string) {
        this.terms = terms;
    }


}
